// src/InventoryModal.js - MODIFICATO

import React, { useState, useEffect } from 'react';

export function InventoryModal({ itemData, onSave, onClose }) {
    const [name, setName] = useState('');
    const [quantity, setQuantity] = useState(0);
    const [minThreshold, setMinThreshold] = useState(0);
    const [barcode, setBarcode] = useState(''); // Stato per il codice a barre

    useEffect(() => {
        if (itemData) {
            setName(itemData.name || '');
            setQuantity(itemData.quantity || 0);
            setMinThreshold(itemData.minThreshold || 0);
            setBarcode(itemData.barcode || ''); // Carica il codice a barre
        }
    }, [itemData]);

    const handleSave = () => {
        if (!name.trim()) {
            alert("Il nome dell'articolo è obbligatorio.");
            return;
        }
        onSave({
            id: itemData?.id,
            name: name.trim(),
            quantity,
            minThreshold,
            barcode, // Invia il codice a barre al salvataggio
        });
    };

    return (
        <div className="modal" onMouseDown={onClose}>
            <div className="modal-content" onMouseDown={e => e.stopPropagation()}>
                <h3>{itemData ? 'Modifica Articolo' : 'Nuovo Articolo'}</h3>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', textAlign: 'left', marginTop: '20px' }}>
                    <div>
                        <label htmlFor="item-name" style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Nome Articolo</label>
                        <input id="item-name" type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome articolo" />
                    </div>
                    
                    {/* Aggiunto campo per il codice a barre */}
                    <div>
                        <label htmlFor="item-barcode" style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Codice a Barre (Opzionale)</label>
                        <input id="item-barcode" type="text" value={barcode} onChange={(e) => setBarcode(e.target.value)} placeholder="Scansiona o inserisci il codice" />
                    </div>

                    <div style={{ display: 'flex', gap: '15px' }}>
                        <div style={{ flex: 1 }}>
                            <label htmlFor="item-quantity" style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Quantità</label>
                            <input id="item-quantity" type="number" value={quantity} onChange={(e) => setQuantity(e.target.value)} placeholder="Es. 10" />
                        </div>
                        <div style={{ flex: 1 }}>
                            <label htmlFor="item-threshold" style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Soglia Minima</label>
                            <input id="item-threshold" type="number" value={minThreshold} onChange={(e) => setMinThreshold(e.target.value)} placeholder="Es. 3" />
                        </div>
                    </div>
                </div>

                <div>
                    <button onClick={handleSave} className="modal-button confirm-button" style={{ marginTop: '25px' }}>Salva</button>
                    <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
                </div>
            </div>
        </div>
    );
}
